import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ModalService } from '../shared/modal/modal.service';
import { SupportComponent } from '../shared/modal/support/support.component';
import { ChatBotComponent } from '../shared/chat-bot/chat-bot.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-auth-wrapper',
  templateUrl: './auth-wrapper.component.html',
  styleUrls: ['./auth-wrapper.component.css']
})
export class AuthWrapperComponent implements OnInit {
  mobHeight: number;
  constructor(public dialog: MatDialog, public global: GlobalService) { 
    this.mobHeight = document.body.clientHeight - 70;
    this.global.featChatBot = JSON.parse(localStorage.getItem('featChatBot'));
  }

  ngOnInit() {
  }

  hide: boolean = false;
  hideSupportFAB(hide){
    this.hide = hide;
  }

  supportModal(): void {
      const dialogRef = this.dialog.open(SupportComponent, {
        //width: '500px',
        //height: '700px',
        data: { }
      });
    }
  
    chatbotModal(): void {
       var winFeature = 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,' + 'width=450px, height=810px';
      window.open('/#/chatbot', 'window', winFeature);
  
      /* const dialogRef = this.dialog.open(ChatBotComponent, {
        width: '450px',
        height: '700px',
        data: { }
      }); */
    }
}
